module.exports = __webpack_public_path__ + "img/06.bab710d8.jpg";